module.exports = __webpack_public_path__ + "img/personal_resources_collect-cancel.28a09856.svg";